'use strict';

define(
    'Races',[
        'RaceMTPFilter',
        'MtpDisplayModel',
        'RaceStatusLabelDir',
        'RaceMtpLabelMod',
    ],

    function (
            RaceMTPFilter,
            MtpDisplay,
            RaceStatusLabelDir,
            RaceMtpLabelMod
        ) {

        angular.module('TVG.Races', [
                'TVG.RaceMTPLabel',
                'TVG.Common.GTM'
        ])

            .filter('raceMtp', RaceMTPFilter)

            .directive('raceStatusLabel', RaceStatusLabelDir)
            .directive('mtpIcon', function() {
                return {
                    restrict: '',
                    replace: true,
                    scope: {
                        racePostTime: '=',
                        mtp: '='
                    },
                    template: ['<i class="tvg-icon-mtp"',
                        'ng-class="{',
                            '\'mtp-near\' : mtpDisplay.mtpStatus == \'near\',',
                            '\'mtp-med\' : mtpDisplay.mtpStatus == \'med\',',
                            '\'mtp-far\' : mtpDisplay.mtpStatus == \'far\'}"',
                            'ng-show="mtpDisplay.mtpStatus && mtpDisplay.mtpStatus != \'time-format\'"></i>'].join(''),
                    link: function (scope) {
                        scope.mtpDisplay = {};

                        function _setMtpDisplay() {
                            scope.mtpDisplay = new MtpDisplay(scope.racePostTime, scope.mtp);
                        }

                        (function init(){
                            _setMtpDisplay();
                        }());

                        scope.$watch('racePostTime', _setMtpDisplay);
                        scope.$watch('mtp', _setMtpDisplay);
                    }
                };
            });
    }
);

